document.addEventListener("DOMContentLoaded", (event) => {
    const tabHeadings = document.querySelectorAll(".membership-quick-tab");
    const containers = document.querySelectorAll(".main-tab-container");

    tabHeadings.forEach(tabHead => {
    tabHead.addEventListener("click", () => {
        const tabId = tabHead.id;

        // Remove active class from all tab headings
        tabHeadings.forEach(th => th.classList.remove("active"));

        // Add active to clicked tab
        tabHead.classList.add("active");

        // Loop containers to match tabId with data-tab
        containers.forEach(container => {
        if (container.dataset.tab === tabId) {
            container.classList.add("active");
        } else {
            container.classList.remove("active");
        }
        });
    });
    });
})
